module.exports = __webpack_public_path__ + "static/media/heliTakeoff.5a9e8886.png";